/**
 * Settings page — redirects to Profile where all profile/directory info lives.
 *
 * Route: /settings
 */

import { Navigate } from 'react-router-dom'

export function Settings() {
  return <Navigate to="/profile" replace />
}

export default Settings
